<template>

  <div class="vflex">
    <div class="vflex-row-1">
      <div class="hflex">
        <div
          class="hflex-col-0 hflex-options-left p-2"
          :style="{'min-width': '240px'}">

          <div v-tooltip="!resourceAvailability.features.includes('custom_reports') ? 'Faça upgrade do plano' : null">
            <button
              v-if="permissions.includes('manage_settings')"
              type="button"
              class="btn btn-primary btn-block mb-2"
              @click="showCreateModal()"
              :disabled="!resourceAvailability.features.includes('custom_reports')">
              + {{ $t('New dashboard') }}
              </button>
          </div>

          <div
            v-if="resourceAvailability.features.includes('custom_reports')"
            v-sortable="{ handle: '.sortable-move', items: newDashboards, onUpdate: reorder }"
            class="list-group mb-3">
            <router-link
              class="list-group-item list-group-item-action sortable-move"
              v-for="(item, index) in newDashboards"
              :key="index"
              :to="`/dashboards/${item._id}`"
              :class="{ 'list-group-item-secondary': dashboard._id === item._id }">
              <a
                v-if="permissions.includes('manage_settings')"
                href="javascript:void(0)"
                class="sortable-move"><i class="fas fa-arrows-alt" /></a>
              {{ item.name }}
            </router-link>
          </div>

          <div
            class="list-group">
            <router-link
              class="list-group-item list-group-item-action sortable-move"
              v-for="(item, index) in fixedDashboards"
              :key="index"
              :to="`/dashboards/${item._id}`"
              :class="{ 'list-group-item-secondary': dashboard._id === item._id }">
              {{ $t(item.name) }}
            </router-link>
          </div>

          <router-link
            class="btn mt-2 btn-sm btn-link btn-block"
            to="/reports/disqualify-reasons?menu_open=true">
            {{ $t('Reports 1.0') }}
          </router-link>

          <dashboard-form 
            v-if="modal_select"
            :initDashboard="modal_select" 
            @hideModal="hideModal()"
            @deleted="loadData(); hideModal()" 
            @saved="loadData(paginate.page); hideModal()">
            </dashboard-form>
        </div>

        <div class="hflex-col-1">
          <router-view></router-view>
        </div>

      </div>
    </div>
  </div>

</template>

<script>
import InputKeyword from '@/components/Fields/InputKeyword'
import ThSort from '@/components/Parts/ThSort'
import DashboardForm from './DashboardForm'
import Paginaty from '@/components/Paginaty/Paginaty'

export default {
  name: 'Dashboard',
  components: {
    DashboardForm,
    ThSort,
    InputKeyword,
    Paginaty
  },
  data () {
    return {
      creating: true,
      loading: true,
      modal_select: false,
      filters: {},
      sort: 'fixed,position',
      selected: []
    }
  },
  computed: {
    resourceAvailability () {
      return this.$store.getters.getAccountResourceAvailability
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    dashboards () {
      return this.$store.getters.getDashboards
    },
    newDashboards () {
      return this.dashboards.filter(v => !v.fixed)
    },
    fixedDashboards () {
      return this.dashboards.filter(v => v.fixed)
    },
    dashboard () {
      return this.$store.getters.getDashboard
    },
    paginate () {
      return this.$store.getters.getDashboardsPaginate
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    modal
    */
    showCreateModal () {
      this.modal_select = {}
    },
    showEditModal (item) {
      this.modal_select = item
    },
    hideModal () {
      this.modal_select = false
    },
    /*
    filters
    */
    setKeywords (keywords) {
      this.filters = keywords ? {name: '~' + keywords} : {}
      this.loadData(1)
    },
    setSort (sort) {
      this.sort = sort
      this.loadData(1)
    },
    /*
    loadData
    */
    loadData (page) {
      this.loading = true

      const params = {
        ...this.filters,
        page: page,
        sort: this.sort,
        limit: this.$default.limit
      }

      this.$store
      .dispatch('selectDashboards', params)
      .then(result => {
        if (!this.dashboard._id) {
          this.$router.push({ path: '/dashboards/' + result[0]._id })
        }
        this.loading = this.creating = false
      })
    },
    /*
    reorder
    */
    reorder (items) {
      Promise.all(items.map((item, index) => {
        return this.$store.dispatch('updateDashboard', { _id: item._id, position: index })
      })).then(() => {
        this.loadData(1)
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue